import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { notesList } from "../../_actions";
import FontAwesome from "react-fontawesome";
import DeviceSmallIcon from "../../_icons/DeviceSmallIcon";
import "./index.css";
import { Checkbox, Row, Col } from "react-bootstrap";

class DeviceCard extends Component {
  getStatusName = val => {
    if (
      this.props.configList === undefined ||
      this.props.configList.device_statuses.length < 1
    ) {
      return null;
    }

    let device_status;
    this.props.configList.device_statuses.forEach(function (item) {
      if (val === item.status) {
        device_status = item;
      }
    });
    return device_status.display_name;
  };

  getPrecincts = precincts => {
    if (precincts.length > 0)
      return (
        <span>
          {precincts.map(function (item, i) {
            return (
              <span key={i}>
                {i > 0 ? ", " : null}
                {item.name}
              </span>
            );
          })}
        </span>
      );
    else {
      return <span>-</span>;
    }
  };

  renderTitleRow = item => {
    return (
      <div className="row-title">
        <Link to={"/device/" + item.id}>
          <DeviceSmallIcon className="small-icon" fill="#111111" /> {item.name}{" "}
        </Link>
        {this.renderStatus(item)}
      </div>
    );
  };

  renderStatus = item => {
    // Unmonitored locations shouldn't have a status displayed at all
    if (item.status === "unmonitored") {
      return "";
    } else {
      return (
        <div className="device-status">
          <FontAwesome
            className={"icon-tab fa-xs status-" + item.status}
            name="circle"
          />
          <span className={"status-" + item.status}>
            {this.getStatusName(item.status)}
          </span>
        </div>
      );
    }
  };

  renderSecondRow = item => {
    return (
      <Row>
        <Col md={3}>
          <div className="row-columns">
            <div className="card-datum">
              <span className="card-datum-name">Device ID</span>
              <span className="card-datum-value">{item.device_id}</span>
            </div>
          </div>
        </Col>
        <Col md={3}>
          <div className="row-columns">
            <div className="card-datum">
              <span className="card-datum-name">Device Type</span>
              <span className="card-datum-value">
                {item.device_type_display}
              </span>
            </div>
          </div>
        </Col>
        <Col md={3}>
          <div className="row-columns">
            <div className="card-datum">
              <span className="card-datum-name">Precinct</span>
              <span className="card-datum-value">
                {this.getPrecincts(item.precincts)}
              </span>
            </div>
          </div>
        </Col>
        <Col md={3}>
          <div className="row-columns">
            <div className="card-datum">
              <span className="card-datum-name">Reporting Status</span>
              <span className="card-datum-value">
                {item.telemetry_status === "unknown" ? "--" : item.telemetry_status_display}
              </span>
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  render = () => {
    const { item } = this.props;

    return (
      <div className="mainDevicePanel">
        <div className="devicePanel">
          <div className="checkbox-column">
            <Checkbox name="status" className="styled-checkbox">
              <span className="checkmark" />
            </Checkbox>
          </div>
          <div className="content-column">
            <div>
              {this.renderTitleRow(item)}
              {this.renderSecondRow(item)}
            </div>
          </div>
          <div className="action-column">
            <Link className="link" to={"/device/" + item.id}>
              View Device
            </Link>
          </div>
        </div>
      </div>
    );
  };
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  const { configList } = state.configuration;
  return {
    user,
    configList
  };
}

export default connect(
  mapStateToProps,
  { notesList }
)(DeviceCard);



// WEBPACK FOOTER //
// ./src/_components/DeviceCard/index.js